<template>
  <modal
    name="campaign-sent"
    :adaptive="true"
    :click-to-close="false"
    height="auto"
    width="90%"
    :max-width="800"
    :pivot-y="0.2"
    class="campaign-sent-modal"
    @closed="onModalClose"
  >
    <Button class="close-button" @click="$modal.hide('campaign-sent')">
      <v-icon slot="icon-end" name="times" />
    </Button>

    <div class="text-center md:py-8">
      <img
        src="https://media.giphy.com/media/JltOMwYmi0VrO/giphy.gif"
        alt="Seinfeld celebrating gif"
        class="rounded-lg mb-6 lg:mb-10 shadow-lg"
      />

      <h1 class="mb-3 title">
        Your campaign is now sending!
      </h1>
      <p class="text-grey-dark text-sm mb-6 md:mb-8">
        Check back soon for the latest stats.
      </p>

      <Review class="framed shadow" title="How are we doing?" />
    </div>
  </modal>
</template>

<script>
import Review from "@/components/Feedback/Review";

export default {
  name: "CampaignSentModal",
  components: { Review },
  methods: {
    onModalClose() {
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>
.campaign-sent-modal >>> .v--modal {
  @apply p-4;
}

.title {
  @apply text-support-light text-xl;
}
</style>
